module.exports = __webpack_public_path__ + "img/50844a4.svg";